import React from 'react';
import PropTypes from 'prop-types';
import EditRetailerForm from './Form';
import AdminNav from '../../admin/AdminNav';

const EditRetailerView = ({ data }) => {
  return (
    <div>
      <AdminNav />
      <h1>Edit retailer</h1>
      <EditRetailerForm id={data._id} initialData={data} />
    </div>
  );
};

EditRetailerView.propTypes = {
  data: PropTypes.shape({
    _id: PropTypes.string,
  }).isRequired,
};

export default EditRetailerView;
